import { render, staticRenderFns } from "./student_grade.vue?vue&type=template&id=28d95cad&scoped=true&"
import script from "./student_grade.vue?vue&type=script&lang=js&"
export * from "./student_grade.vue?vue&type=script&lang=js&"
import style0 from "./student_grade.vue?vue&type=style&index=0&id=28d95cad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d95cad",
  null
  
)

export default component.exports